import { LoanCalculationInputs } from '../../container/newCalculator/newCalculator.models'

export enum LocalStorageKeys {
	// Add other local storage keys here as needed
	PLACEHOLDER = 'placeholder', // Remove this when adding real keys
	CALCULATOR_DATA = 'calculatorData',
}

/**
 * Wrapper for browser storage functions to check if we have the window object before continuing.
 * getItem returns string or null
 * setItem, removeItem, etc. return void
 * @param fn - storage function to wrap (e.g. window.localStorage.getItem)
 */
export const withWindowDefined = (fn: () => string | null | void) => {
	if (typeof window !== 'undefined') {
		return fn()
	}
	return undefined
}

export const getLocalStorageItem = (key: LocalStorageKeys): string | undefined => {
	return withWindowDefined(() => window.localStorage.getItem(key)) ?? undefined
}

export const setLocalStorageItem = (key: LocalStorageKeys, value: string): void => {
	withWindowDefined(() => window.localStorage.setItem(key, value))
}

export const removeLocalStorageItem = (key: LocalStorageKeys): void => {
	withWindowDefined(() => window.localStorage.removeItem(key))
}

export const setCalculatorDataToLocalStorage = (
	ASSET_FORMATION: LoanCalculationInputs,
	PAYMENT_REDUCTION: LoanCalculationInputs
): void => {
	const data = { ASSET_FORMATION, PAYMENT_REDUCTION }
	setLocalStorageItem(LocalStorageKeys.CALCULATOR_DATA, JSON.stringify(data))
}

export const getCalculatorDataFromLocalStorage = ():
	{ ASSET_FORMATION: LoanCalculationInputs; PAYMENT_REDUCTION: LoanCalculationInputs } | undefined => {
	const data = getLocalStorageItem(LocalStorageKeys.CALCULATOR_DATA)
	return data ? JSON.parse(data) : undefined
}

export const deleteCalculatorDataFromLocalStorage = (): void => {
	removeLocalStorageItem(LocalStorageKeys.CALCULATOR_DATA)
}
